const AccountTypeEnum = Object.freeze({
    PLATFORM: 'PLATFORM',
    FUND: 'FUND',
    ISA: 'ISA',
    ISAFUND: 'ISAFUND',
    FEE: 'FEE'
});

export default AccountTypeEnum;
